$(document).ready(function () {
    const $search = $('.js-searchPostings');
    const $postingsList = $('.js-allPostingsList');
    const $searchButton = $('.js-searchButton');
    const $clearButton = $('.js-clearPostings');

    $postingsList.children().hide()

    function debounce(func, wait) {
        let timeout;
        return function() {
            const context = this, args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    };

    function search() {
        const query = $search.val().toLowerCase();
        if (query.length >= 2) {
            $clearButton.show();
            $postingsList.children().each(function() {
                const searchableText = $(this).data('search').toLowerCase();
                if (searchableText.includes(query)) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
        } else {
            $clearButton.hide();
            $postingsList.children().hide();
        }
    };

    $search.on('input', debounce(search, 200));
    $searchButton.on('click', function() {
        search();
    });
    $clearButton.on('click', function() {
        $search.val('');
        search();
    });
});